// extracted by mini-css-extract-plugin
export var animationContainer = "_hf-0";
export var asteriskIcon = "_hf-8";
export var conversationLeftSection = "_hf-4";
export var conversationListItem = "_hf-3";
export var conversationMiddleSection = "_hf-5";
export var conversationRightSection = "_hf-6";
export var detailsContent = "_hf-1";
export var listContainer = "_hf-7";
export var modalContent = "_hf-2";